import { Filter, Grid3X3, ListFilter, SlidersHorizontal } from "lucide-react";
import { ProductCard } from "../../components/commerce/ProductCard";
import { categoryGroups } from "../../data/navigation";
import { products } from "../../data/products";

export function CategoryPage() {
  return (
    <main className="page-canvas">
      <section className="container listing-layout">
        <aside className="filter-panel">
          <div className="filter-head">
            <Filter aria-hidden="true" />
            <strong>Bộ lọc</strong>
          </div>
          <label>
            Nhóm hàng
            <select defaultValue="xe-dien">
              <option value="xe-dien">Xe điện</option>
              <option value="xe-may">Xe máy</option>
              <option value="oto-dien">Ô tô điện</option>
            </select>
          </label>
          <label>
            Điện áp
            <select defaultValue="60v">
              <option value="60v">60V</option>
              <option value="48v">48V</option>
              <option value="72v">72V</option>
            </select>
          </label>
          <label>
            Tình trạng
            <select defaultValue="in-stock">
              <option value="in-stock">Có sẵn</option>
              <option value="low-stock">Tồn thấp</option>
              <option value="preorder">Đặt trước</option>
            </select>
          </label>
        </aside>
        <section className="listing-main">
          <div className="listing-head">
            <div>
              <h1>Phụ tùng xe điện</h1>
              <p>Sidebar desktop, filter sheet mobile, sort/grid/list theo đúng rule V3.1.</p>
            </div>
            <div className="listing-actions">
              <button type="button">
                <SlidersHorizontal aria-hidden="true" /> Lọc
              </button>
              <button type="button">
                <Grid3X3 aria-hidden="true" /> Grid
              </button>
              <button type="button">
                <ListFilter aria-hidden="true" /> Sắp xếp
              </button>
            </div>
          </div>
          <div className="quick-filter">
            {categoryGroups.map((group) => (
              <button key={group.title} type="button">
                {group.title}
              </button>
            ))}
          </div>
          <div className="product-grid listing-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </section>
      </section>
    </main>
  );
}
